import type { ApiClient } from 'clients/yogi-api'

const HASH_FILTER_URL = '/project/hash-filter'

export class ScreenLinkService {
  constructor(private client: ApiClient) {}

  /**
   * Creates a filter hash for cross-page link building.
   *
   * `filterString` is a JSON-stringified v2 hash body (`{v2: {panels, ...}}`,
   * the same envelope `ChartsV2StateService.save` writes) — PROD-5847 dropped
   * the v1 `filters`/`pageControls` write path. See
   * `features/charts-v2/utils/chart-artifact-to-panels.ts`'s
   * `buildChartsV2State` for the canonical single-panel envelope builder.
   *
   * @param proj_uuid - The project UUID
   * @param body - `{ page, filterString }` — the hash-filter request body.
   *   `page` is optional because several callers derive it from
   *   `getCurrentRouteName`, which can return `undefined` off-route; the
   *   backend's `page` field already defaults to `""` when omitted.
   * @returns The filter hash string
   */
  createFilterHash(
    proj_uuid: string,
    body: { page: string | undefined; filterString: string },
  ): Promise<string> {
    return this.client
      .post<string>(HASH_FILTER_URL, body, {
        params: { proj_uuid },
      })
      .then(({ data }) => data)
  }
}
